import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { Accordion } from 'us-react-components/dist/Accordion/Accordion';
import { useDependencies } from '../../../dependencies';
import { VoucherItem } from './VoucherItem';

export const InactiveCredits = observer((): JSX.Element | null => {
  const { t } = useTranslation();
  const { stores } = useDependencies();
  const { inactiveCredits } = stores.credits;

  if (!inactiveCredits || !inactiveCredits?.data?.data?.length) {
    return null;
  }

  return (
    <div>
      <Accordion headerText={t('pages.credits.inactiveCreditsHeader')}>
        <VoucherItem userVouchers={inactiveCredits} active={false} />
      </Accordion>
    </div>
  );
});
